import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'courses',
  path: () => `/courses`,
}

export default ROUTE
